"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M16.044 7.963H8.852a.76.76 0 01.756-.763h6.436a.76.76 0 01.756.763v6.495a.76.76 0 01-.756.763V7.963z" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.01 8.776h6.332c.447 0 .81.366.81.817v6.39a.814.814 0 01-.81.817H8.01a.813.813 0 01-.81-.817v-6.39c0-.451.363-.817.81-.817zm1.632 4.948l-1.68 2.14h6.434l-2.449-3.119-1.536 1.958-.77-.979z" })), "Gallery");
//# sourceMappingURL=Gallery.js.map